export default __webpack_public_path__ + "static/media/flowers_long.672bcf2c.jpg";